import { render } from "./WarningsComponent.vue?vue&type=template&id=8bd5736e"
import script from "./WarningsComponent.vue?vue&type=script&lang=js"
export * from "./WarningsComponent.vue?vue&type=script&lang=js"

import "./WarningsComponent.vue?vue&type=style&index=0&id=8bd5736e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__